<template>
  <div class="basic-info account-page">
    <div class="header">
      <div class="title">基本资料</div>
    </div>
    <div class="base-user-info">

      <!--      行业信息-->
      <div>
        <div class="sub-title">行业信息</div>
        <div class="row clearfix">
          <div class="left requisite">行业分类：</div>
          <div class="right">
            <el-select v-model="industry" placeholder="" style="width: 100%;">
              <el-option
                v-for="item in industryList"
                :key="item.id"
                :label="item.title"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
		  <div class="error">{{error.industry}}</div>
        </div>
        <div class="row clearfix">
          <div class="left">行业详情：</div>
          <div class="right">
            <el-input v-model="basicInfo.industry_info"></el-input>
          </div>
        </div>
      </div>
      <!--      联系人信息-->
      <div>
        <div class="sub-title">联系信息</div>
        <div class="row clearfix">
          <div class="left requisite">所在地区：</div>
          <div class="right" style="width: 380px;">
            <addr-three-select v-model="regionCode"></addr-three-select>
          </div>
		  <div class="error">{{error.regionCode}}</div>
        </div>
        <div class="row clearfix">
          <div class="left">街道地址：</div>
          <div class="right">
            <el-input v-model="basicInfo.addr"></el-input>
          </div>
        </div>
        <div class="row clearfix">
          <div class="left">联系电话：</div>
          <div class="right">
            <el-input v-model="basicInfo.tel"></el-input>
          </div>
        </div>
        <div class="row clearfix">
          <div class="left">传真：</div>
          <div class="right">
            <el-input v-model="basicInfo.fax"></el-input>
          </div>
        </div>
      </div>
      <!--      企业信息-->
      <div v-if="$store.state.userAuth==20">
        <div class="sub-title">企业信息</div>
        <div class="row clearfix">
          <div class="left">企业logo：</div>
          <div class="right">
			  <div v-if="logoImg">
				  <img :src="this.logoImg" alt="">
			  </div>
			  <el-upload
			    class="upload-demo"
			    ref="upload"
			    action="#"
				:on-change="changeAvatarUpload"
			    :on-preview="handlePreview"
			    :on-remove="handleRemove"
			    :file-list="fileList"
			    :auto-upload="false"
				:limit="1"
				list-type="picture">
			    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
			    <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
			    <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2Mb</div>
			  </el-upload>
          </div>
        </div>
        <div class="row clearfix">
          <div class="left">企业规模：</div>
          <div class="right">
            <el-select v-model="entInfo.scale" placeholder="" style="width: 100%;">
              <el-option
                v-for="item in scaleList"
                :key="item.id"
                :label="item.title"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row clearfix">
          <div class="left">企业网站：</div>
          <div class="right">
            <el-input v-model="entInfo.website"></el-input>
          </div>
        </div>
        <div class="row clearfix">
          <div class="left">企业简介：</div>
          <div class="right_all">
            <div class="wangEditor" ref="editorDom"></div>
          </div>
        </div>
      </div>
	  <el-button type="primary" @click="submitmodify">提交</el-button>
    </div>
  </div>
</template>

<script>
  import Editor from "wangeditor"
  import AddrThreeSelect from '@/components/fields/AddrThreeSelect'

  export default {
    name: 'BaseInfo',
    components: {
      AddrThreeSelect,
    },
    data() {
      return {
        auth: 0,
		industryList: [],
		industry: '',
		scaleList: '',
		basicInfo: {
			industry_info: '',
			addr: '',
			tel: '',
			fax: ''
		},
		entInfo: {
			scale: '',
			website: '',
		},
		logoImg: '',
		logofile: {},
		fileList: [],
        editor: null,
		editorContent: '',
        regionCode: '',
		error: {
			industry: '',
			regionCode: '',
		}
      }
    },
    methods: {
		isEmptyObject(obj){
			for(var key in obj) {
				return false;
			}
			return true;
		},
		handleRemove(file, fileList) {
		        console.log(file, fileList);
				this.$api.user.dellogo().then(res => {
						  console.log(res)
				})
		      },
		      handlePreview(file) {
		        console.log(file);
		      },
			  submitUpload() {
				 this.$api.user.entLogo(this.logofile).then(res => {
				 console.log(res)
				 if (res.code === 0){
					this.$message({message: '上传logo成功', type: 'success', offset: 80})
				 } else {
					 this.$message.error({message: '上传logo失败，请重试', offset: 80})
				 }
				 })
			  },
			  changeAvatarUpload(file){
			  		this.logofile = file.raw
			  		console.log(this.logofile)
			  },
			  submitmodify() {
				  this.$api.user.modifyuserinfo(this.regionCode,this.basicInfo.addr,this.basicInfo.tel,this.basicInfo.fax,
				  this.industry,this.basicInfo.industry_info,this.entInfo.scale,this.editorContent,this.entInfo.website).then(res => {
				  console.log(res)
				  if (res.code === 0){
					this.$message({message: '修改资料成功', type: 'success', offset: 80})
				  } else {
					this.$message.error({message: '修改资料失败，请重试', offset: 80})
				  }
				  })
			  },
			  createEditor() {
				  this.editor = new Editor(this.$refs.editorDom)
				  this.editor.customConfig.onchange = (html) => {
					  this.editorContent = html
				  }
				  this.editor.customConfig.menus = [
					'head',
					'bold',
					'fontSize',
					'fontName',
					'italic',
					'underline',
					'strikeThrough',
					'foreColor',
					'backColor',
					'list',
					'justify',
					'quote',
					'image',
					'table',
					'undo',
					'redo',
				]
				  // this.editor.customConfig.uploadImgShowBase64 = true
				  // this.editor.customConfig.debug = true
				  this.editor.customConfig.uploadImgServer = 'http://192.168.1.222:8000/v1/u/resource/public'
				  this.editor.customConfig.uploadFileName = 'file'
				  this.editor.customConfig.uploadImgHeaders = {
					  // 'Accept': 'application/json, text/plain, */*',
				      // 'Content-Type': 'multipart/form-data',
					  'token': this.$cookies.get('token')
				  }
				  this.editor.customConfig.uploadImgParams = {
				      // 如果版本 <=v3.1.0 ，属性值会自动进行 encode ，此处无需 encode
				      // 如果版本 >=v3.1.1 ，属性值不会自动 encode ，如有需要自己手动 encode
				      type: '1',
				  }
				  this.editor.customConfig.uploadImgHooks = {
				      // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
				      // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
				      customInsert: function (insertImg, result, editor) {
				          // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
				          // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
				  
				          // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
				          var url = result.data.url
				          insertImg(url)
				  
				          // result 必须是一个 JSON 格式字符串！！！否则报错
				      }
				  }
				  this.editor.customConfig.showLinkImg = false
				  this.editor.create()
			  }
	},
	mounted () {
		if(this.$store.state.userAuth == 20){
			this.createEditor()
		}
	},
    created() {
	this.$api.common.industry().then(res => {
			this.industryList = res.data
			console.log(this.industryList)
	})
      this.$api.user.getUserInfo().then(res => {
		// this.fileList[0].name = 'logo.jpg'
		// this.fileList[0].url = res.data.ent_info.logo
		// this.logoImg = res.data.ent_info.logo
		if (res.code === 0){
			console.log(res)
			// this.auth = res.data.user_info.auth
			if (this.$store.state.userAuth == 20){
				if (this.isEmptyObject(res.data.basic_info) || this.isEmptyObject(res.data.ent_info)){
					return
				} else {
					this.basicInfo = res.data.basic_info
					this.industry = res.data.basic_info.industry.id
					if (this.industry === 0){
						this.industry = ''
					}
					this.entInfo = res.data.ent_info
					this.regionCode = this.basicInfo.region_code
					this.editorContent = this.entInfo.intro
					this.editor.txt.html(this.editorContent)
					this.basicInfo.industry = res.data.basic_info.id
					// console.log(this.basicInfo.industry)
					if (this.entInfo.logo !== '') {
						this.fileList.push({'name': 'logo.jpg', 'url': res.data.ent_info.logo})
					} else {
						return
					}
				}
			} else {
				if (this.isEmptyObject(res.data.basic_info)){
					// console.log('空')
					return
				} else {
					this.basicInfo = {...this.basicInfo, ...res.data.basic_info}
					console.log(this.basicInfo)
					this.industry = res.data.basic_info.industry.id
					if (this.industry === 0){
						this.industry = ''
					}
					this.regionCode = this.basicInfo.region_code
				}
			}
		} 
      })
	  this.$api.common.entScale().then(res => {
	  		  this.scaleList = res.data
	  })
    },
  }
</script>

<style scoped>
  .base-user-info {
    width: 100%;
  }

  .sub-title {
    margin-top: 20px;
    font-size: 16px;
  }

  .row {
    margin-bottom: 15px;
  }

  .left {
    float: left;
    width: 130px;
    line-height: 40px;
    text-align: right;
  }

  .right {
    float: left;
    width: 300px;
    padding-left: 30px;

  }
  .error {
	float: left;
	padding-left: 30px;
	color: red;
	height: 20px;
	line-height: 40px;
  }
  .right_all {
    float: left;
    padding-left: 30px;
  }
  .wangEditor{
	  text-align: left;
	  width: 700px;
  }
</style>
